/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface F1TerminalSoftpayReceiptDto
 */
export interface F1TerminalSoftpayReceiptDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof F1TerminalSoftpayReceiptDto
     */
    receipt: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof F1TerminalSoftpayReceiptDto
     */
    formatOptions?: { [key: string]: string; };
}

/**
 * Check if a given object implements the F1TerminalSoftpayReceiptDto interface.
 */
export function instanceOfF1TerminalSoftpayReceiptDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "receipt" in value;

    return isInstance;
}

export function F1TerminalSoftpayReceiptDtoFromJSON(json: any): F1TerminalSoftpayReceiptDto {
    return F1TerminalSoftpayReceiptDtoFromJSONTyped(json, false);
}

export function F1TerminalSoftpayReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): F1TerminalSoftpayReceiptDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'receipt': json['receipt'],
        'formatOptions': !exists(json, 'formatOptions') ? undefined : json['formatOptions'],
    };
}

export function F1TerminalSoftpayReceiptDtoToJSON(value?: F1TerminalSoftpayReceiptDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'receipt': value.receipt,
        'formatOptions': value.formatOptions,
    };
}

